export default __webpack_public_path__ + "static/media/info_icon_bg.0d961a48.svg";